import {useIsAdmin} from "@/hooks/useUserHooks";
import useUserStore from "@/store/user";
import {type FC, memo, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router";
import {Tooltip} from "react-tooltip";

const EmptySocialLink: FC<{socialPlatform: "instagram" | "tiktok"}> = ({socialPlatform}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();
  const subscription = useUserStore(state => state.user.package_subscription);

  const navigationTarget = useMemo(
    () => (subscription?.status === "trialing" ? "/" : "/plans/"),
    [subscription?.status],
  );
  const tooltipTranslationKey = useMemo(() => {
    if (!subscription) {
      return "purchase_plan_to_see";
    }

    if (subscription.status === "trialing") {
      return "start_your_first_campaign";
    }

    if (
      (socialPlatform === "instagram" && subscription.package_category === "TIKTOK") ||
      (socialPlatform === "tiktok" && subscription.package_category === "INSTAGRAM")
    ) {
      return "upgrade_to_see";
    }

    return "";
  }, [subscription, socialPlatform]);

  if (isAdmin || !tooltipTranslationKey) {
    return <span className="text-neutral-black">--</span>;
  }

  return (
    <>
      <button
        data-tooltip-id="blurred-social-link"
        onClick={e => {
          e.stopPropagation();
          navigate(navigationTarget);
        }}
        className="border-neutral-grey-lightest h-3 rounded-sm border bg-linear-(--blur-button-gradient) px-8 text-[10px]"
      />
      <Tooltip id="blurred-social-link" variant="dark" place="bottom">
        {t(tooltipTranslationKey)}
      </Tooltip>
    </>
  );
};

export default memo(EmptySocialLink);
